import { forwardRef, createElement } from 'react';
import { aM as TextArea$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var TextArea = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/createElement(TextArea$1, __assign({}, props, {
    ref: ref
  }));
});
TextArea.displayName = 'TextArea';

export { TextArea };
